(function () {
  function closeAll(except) {
    document.querySelectorAll("details.cm-lineup-popup[open]").forEach(function (d) {
      if (d !== except) d.removeAttribute("open");
    });
  }
  document.addEventListener("click", function (e) {
    var open = document.querySelector("details.cm-lineup-popup[open]");
    if (open && !open.contains(e.target)) open.removeAttribute("open");
  });
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (d.matches && d.matches("details.cm-lineup-popup") && d.open) closeAll(d);
  }, true);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
})();